<template>
  <div>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>
  </el-row>

  <el-row v-if="!editMode">
    <el-col :xs="8" :sm="8" :lg="12">
      <el-button v-if="from==''" type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
      </el-button>
      <el-button v-if="from !=''" type="info" @click.prevent="goBackReport" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
      </el-button>
    </el-col>
    <el-col :xs="16" :sm="16" :lg="12" style="text-align: right">
      <el-button v-if="basicForm.status === 'draft'" type="warning" @click.prevent="handleDraft">暫存 <i
          class="el-icon-s-claim"></i></el-button>
      <el-button v-if="basicForm.status === 'draft' || basicForm.status === 'reject'" type="primary" @click.prevent="handleSign" class="mr-20">送簽核 <i
          class="el-icon-s-claim"></i></el-button>

      <template v-if="basicForm.status === 'close'">
        <el-popconfirm
          confirm-button-text="確定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          title="確定作廢此筆資料嗎?"
          @confirm="handleInvalid(form.mytodoId)"
        >
          <el-button size="mini" type="danger" slot="reference" class="mr-10">作廢此單</el-button>
        </el-popconfirm>
      </template>
          
    </el-col>
 </el-row>

    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->

    <!--    基本資料-->
  <el-row v-if="!editMode">  
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
            <el-button style="float: right; padding: 2px 0; margin-top: -12px" type="text">
              <el-tag type="info">{{basicForm.status | fmtSignResult }}</el-tag>
            </el-button>
          </div>
          <div>
            <el-form :model="basicForm" :rules="rules" ref="basicDataForm" label-width="50px" label-position="top">
              <el-row>
                <el-col :xs="12" :sm="12" :md="12">
                  <p>填單人: {{basicForm.userObj.username}} </p>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12">
                  <p>報表日期: {{basicForm.startDate | fmtDate}}</p>
                </el-col>
              </el-row>
              
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <p class="mt-20">請款單編號: {{basicForm.reqPayNo}} </p>
                </el-col>
              </el-row>

              <el-row class="mt-10">
                <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="標題" prop="title" class="mytitle">
                    <el-input v-if="basicForm.status === 'draft'" v-model="basicForm.title" autocomplete="off"></el-input>
                    <el-input v-if="basicForm.status !== 'draft'" readonly v-model="basicForm.title" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <!-- <el-form :model="basicForm" :rules="rules" ref="basicDataForm" label-width="100px">
              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="填單人" prop="userObj.username" >
                    <el-input  readonly v-model="basicForm.userObj.username"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題" prop="title">
                    <el-input v-if="basicForm.status === 'draft'" v-model="basicForm.title" autocomplete="off"></el-input>
                    <el-input v-if="basicForm.status !== 'draft'" readonly v-model="basicForm.title" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="報表日期" prop="startDate" >
                    <el-date-picker v-if="basicForm.status ==='draft'"  type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
                    <el-date-picker v-if="basicForm.status !=='draft'" readonly type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="請款單編號" prop="reqPayNo" >
                    <el-input  readonly v-model="basicForm.reqPayNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form> -->
          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>
   
  <!-- 付款對象 -->
    <el-row v-if="!editMode">
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
         <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>付款對象</span>
            </div>
            <div>
              <el-form class="myform" label-position="top"　:model="basicForm" >
                <div>
                  <el-form-item prop="paymentObject">
                    <el-input v-if="basicForm.status === 'draft'" v-model="basicForm.paymentObject" autocomplete="off"></el-input>
                    <el-input v-if="basicForm.status !== 'draft'" readonly v-model="basicForm.paymentObject" autocomplete="off"></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-card>
      </el-col>
    </el-row>

    <!-- 付款方式 -->
    <el-row v-if="!editMode">
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
         <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>付款方式</span>
            </div>
            <div>
              <el-form class="myform" label-position="top"　:model="basicForm" ref="paymentMethodForm" >
                <el-form-item label="" prop="paymentMethod" >
                  <el-radio :disabled="!canEdit" v-model="basicForm.paymentMethod" label="cash" @change="showField">現金</el-radio>
                  <el-radio :disabled="!canEdit" v-model="basicForm.paymentMethod" label="wire" @change="showField">匯款</el-radio>
                  <!-- <el-radio :disabled="!canEdit" v-model="basicForm.paymentMethod" label="checks" @change="showField">支票</el-radio> -->
                </el-form-item>

                <div v-show="basicForm.paymentMethod === 'wire'">
                  <el-form-item label="抬頭" prop="wireTitle">
                    <el-input v-model="basicForm.wireTitle"></el-input>
                  </el-form-item>
                  <el-form-item label="銀行" prop="wireBank">
                    <el-input v-model="basicForm.wireBank"></el-input>
                  </el-form-item>
                  <el-form-item label="帳號" prop="wireAccount">
                    <el-input v-model="basicForm.wireAccount"></el-input>
                  </el-form-item>
                </div>

                <!-- <div v-show="basicForm.paymentMethod === 'checks'">
                  <el-form-item label="票號" prop="checksNo">
                    <el-input v-model="basicForm.checksNo"></el-input>
                  </el-form-item>
                  <el-form-item label="到期日" prop="checksExpiredDate">
                    <el-date-picker type="date" placeholder="選擇日期" v-model="basicForm.checksExpiredDate"></el-date-picker>
                  </el-form-item>
                </div> -->

              </el-form>
            </div>
          </el-card>
      </el-col>
    </el-row>

  <!--    請款項目 -->
   <el-row v-if="!editMode"> 
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="itemMain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>請款項目</span>
            <el-button v-if="basicForm.status === 'draft'" 
                  style="float: right; padding: 5px 12px" 　
                  type="primary"
                  @click.prevent="handleAddTask" class="mr-20" id="add_task_btn">
                  <i class="el-icon-circle-plus-outline"></i> 新增事由
              </el-button>
          </div>
          
          <div>
            <el-table :show-header="true" :data="task.tableData" empty-text="無資料" stripe :default-expand-all="true">
              
              <el-table-column label="項次" width="50">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}.
                </template>
              </el-table-column>
              <el-table-column label="金額" prop="itemPrice">
                <template slot-scope="scope">
                 NTD{{ scope.row.itemPrice}}
                </template>
              </el-table-column>

              <el-table-column type="expand">
                <template slot-scope="scope">
                  <p class="mt-10">項目內容:</p>
                  <p>
                    <div style="padding:8px; line-height: 1.5; ">
                      {{ scope.row.itemContent }}
                    </div>
                  </p>
                  <p class="mt-20"  v-if="scope.row.fileListDisplay.size>0">附件:</p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>


                    <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆附件嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="removeHistoryFile(f.id)"
                  >
                    <el-button v-if="canEdit" type="danger" slot="reference" size="mini" round><i class="el-icon-error"></i> 刪除</el-button>
                  </el-popconfirm>

                  </li>
                </ol>
                </template>
              </el-table-column>
              
              <el-table-column label="操作" width="120" v-if="basicForm.status === 'draft'">
                <template slot-scope="scope">

                  <el-button type="primary" circle @click="handleEdit(scope.row)"><i class="el-icon-edit"></i></el-button>

                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="taskHandleDeleteHistory(scope.row.id)"
                  >
                  <el-button type="danger" icon="el-icon-delete" circle slot="reference"></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div style="padding: 20px">
            <span>申請總金額 : NTD{{basicForm.totalPrice}}</span>
          </div>

        </el-card>
      </el-main>
    </el-col>
 </el-row>

    <!--    簽核紀錄-->
  <SignOffHistory :editMode="editMode" :canViewSignOff="canViewSignOff"></SignOffHistory>

  
    <el-row v-if="editMode" style="background-color: white; padding:20px"> 
      <el-form id="add_task_form" class="myform mt-20" label-position="top" :model="task.form" ref="taskForm" :rules="taskFormRule" >
        <el-row>
           <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="金額" prop="itemPrice" class="pr-10">
              <el-input  v-model="task.form.itemPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="請款項目內容" prop="itemContent" class="pr-10">
              <el-input type="textarea" rows="7"  placeholder="請輸入項目內容" v-model="task.form.itemContent" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        
        <el-row v-for="(btn, i) in task.btnCount" :key="i" style="background-color: #f4f4f5; padding: 8px; margin-top: 8px;">
            <el-col :xs="12" :sm="12" :md="12" class="pr-10">
              <el-form-item label="檔案備註">
                <el-input placeholder="檔案備註" v-model="task.form.fileNotes[i]" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12">
              <el-form-item label="附件">
                <el-upload
                    :multiple="false"
                    class="upload-demo"
                    action="/api/file/upload"
                    :on-success="taskHandleUploadSuccess"
                    :before-upload="beforeUpload"
                    :on-remove="taskHandleFileRemove">
                  <el-button size="small" type="primary">上傳文件</el-button>
                  <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
        </el-row>

        <el-row class="mb-20 mt-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="taskNewUploadField()">新增上傳</el-button>
          </el-col>
        </el-row>

      </el-form>

      <div style="float: right;">
        <el-button @click="cancelAddTask">取 消</el-button>
        <el-button type="primary" @click="taskFormSave('taskForm')">確 定</el-button>
      </div>

    </el-row>



      <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
  <el-row>
     <el-dialog title="附件圖"
               :visible.sync="img.dialog"
               :width="dw">
        <div class="demo-image">
          <el-image
            style="width: 100%; max-width: 100%; height: 100%;"
            :src="img.url"
            fit="cover" lazy>
              <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i> 開啟中...
            </div>
            </el-image>
        </div>
        
     </el-dialog>
  </el-row>

</div>

</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";
import SignOffHistory from '@/components/signoff/sign-history'

export default {
  name: "PettyCashPage",
  components: {
    Breadcrumb,SignOffHistory
  },
  data() {
    let fieldRequired = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let treeCheck = (rule, value, callback) => {
      let selectedIds = this.$refs.tree.getCheckedKeys();

      if (!selectedIds || selectedIds.length === 0) {
        callback(new Error('請確認出勤前工作'))
      } else {
        callback()
      }
    }

    return {
      from:'',
      editMode: false,
      actionType: '',

      img:{
        dialog: false,
        url:''
      },


      dw: '60%',

      img:{
        dialog: false
      },

      /**主表**/
      
      basicForm: {
        id: '',
        title: '',
        startDate: '',
        userObj: {
          username:''
        },
        status:'',
        endDate: '',
        preCheckItem: '',
        visitRoute: '',
        itemSum:0,
        tax:0,
        taxPrice:0,

        paymentMethod: '',
        paymentObject: '',
        wireTitle: '',
        wireBank: '',
        wireAccount: '',
        checksNo:'',
        checkExpiredDate: '',
        totalPrice:0,
        payArea:''
      },

      form: {
        mytodoId: '',
        custId: '',
        arrivalTime: '',
        deliveryContentChecked: [],
        deliveryContent: '',
        serviceContentChecked: [],
        serviceContent: '',
        paymentReceiveChecked: [],
        paymentReceive: '',
        notes: '',
        fileList: [],
        fileNotes: []
      },

      /**項目紀錄表**/
      task: {
        tableData:[],
        dialog: false,
        form: {
          mytodoId: '',
          id:'',
          fileList:[],
          fileNotes:[],
          itemContent: '',
          itemPrice:0
        },
        btnCount:0
      },

      /**簽核紀錄表**/
      signoff: {
        history:[]
      },

      /**表單validation**/
      rules: {
        title: [{required: true, validator: fieldRequired, trigger: 'change'}],
        startDate: [{required: true, validator: fieldRequired, trigger: 'change'}]
      },
      taskFormRule:{
        itemContent: [{required:true, validator: fieldRequired, trigger: 'change'}],
        itemPrice: [{required:true, validator: fieldRequired, trigger: 'change'}]
      }

    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    canEdit() {
      return this.basicForm.status === 'draft' || this.basicForm.status === 'reject'
    },
    canViewSignOff() {
      return this.basicForm.status === 'reject' || this.basicForm.status === 'close' || this.basicForm.status === 'invalid'
    }
  },
  methods: {
    cancelAddTask(){
      //this.clearInputForm()

      this.editMode = false
      this.$nextTick(()=>{
        document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })
    },
    showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },
    showField() {
      if (this.basicForm.paymentMethod === 'cash') {
        this.basicForm.wireTitle = ''
        this.basicForm.wireBank = ''
        this.basicForm.wireAccount = ''
        this.basicForm.checksNo = ''
        this.basicForm.checksExpiredDate = ''
      } else if (this.basicForm.paymentMethod === 'wire') {
        this.basicForm.checksNo = ''
        this.basicForm.checksExpiredDate = ''
      } else {
        this.basicForm.wireTitle = ''
        this.basicForm.wireBank = ''
        this.basicForm.wireAccount = ''
      }
    },
    subTotalCalculate() {

      let qty = this.task.form.itemQty
      let price = this.task.form.itemPrice
      this.task.form.itemSubTotal = qty * price

      console.log('subTotalCalculate:', this.task.form.itemSubTotal)

    },
    closeTaskDialog() {
      //this.task.form.notes = ''
      this.$refs['taskForm'].resetFields()
      this.task.btnCount = 0
      //this.loadCustomerHistoryData()
    },
    taskHandleUploadSuccess(res, file) {
      this.task.form.fileList.push(res.uuid)
    },
    taskNewUploadField() {
      this.task.btnCount++
    },
    taskHandleFileRemove(file, fileList) {
      this.task.form.fileList = this.task.form.fileList.filter(e => e !== file.response.uuid)
    },
    taskFormSave(formName){
      this.$refs[formName].validate( valid => {
        if (valid) {
          try {
            this.request.post("/todo/petty-cash/history", this.task.form).then(res => {
              if (res.code === '200') {
                this.clearInputForm()
                this.editMode = false
                this.showResult('success', '資料更新成功')

                this.$nextTick(()=>{
                    this.taskHistory()
                    document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
               
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })
    },
    
    handleAddTask() {
      
      
      this.task.form.id = null
      this.task.form.fileList = []
      this.task.form.fileNotes = []
      this.task.btnCount = 0

      this.editMode = true
      this.$nextTick(()=>{
        document.getElementById("add_task_form").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })

    },  

    clearInputForm() {
      this.$refs['taskForm'].resetFields()
    },

    taskHandleDeleteHistory(id) {
      this.request.delete("/todo/petty-cash/history/" + id).then(res => {
        if (res.code === '200') {
          this.taskHistory()
          this.showResult('success', '資料刪除成功.')
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    taskHistory() {
      this.request.get("/todo/petty-cash/history/" + this.task.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.task.tableData = res.data

          
          let totalPrice = 0
          this.task.tableData.forEach(obj => {
            totalPrice += parseInt(obj.itemPrice)
          })
          //產品加總
          console.log('totalPrice:', totalPrice)
          this.basicForm.totalPrice = totalPrice

          

          //this.recalculate()
        } else {
          this.showResult('error', '工作項目紀錄撈取失敗')
        }
      })
    },
    recalculate(){
      let itemSum = this.task.form.itemSum
      let tax = 0
      if(this.task.form.tax === 1) {
        tax = 0.05
      }
      this.task.form.taxPrice = Math.round(itemSum * tax)
      this.task.form.totalPrice = parseInt(itemSum) + parseInt(this.task.form.taxPrice)
    },

    //參數為勾選的值，array
    handleDeliveryChange(selectedItem){
      console.log(selectedItem)
      console.log(selectedItem.includes('指送'))
      if (selectedItem.includes('指送')) {
        this.shippingToDifferentAddress = true
      } else {
        this.shippingToDifferentAddress = false
      }
    },
    handleSelect(item) {
      this.form.custId = item.id
    },
    querySearch(str, cb){
      this.request.get("/customer/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.company + "(" + item.name + ")",
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
    showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    loadCustomerHistoryData() {
      this.request.get("/todo/customer/history/" + this.basicForm.mytodoId).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '客戶拜訪紀錄撈取失敗')
        }
      })
    },
  
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('todo/saveMytodo', this.form)

            this.showResult('success', '資料更新成功.')

            await this.loadCustomerHistoryData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })
    },
    handleSubmitForm() {
      this.request.post("/todo", this.basicForm).then(res => {
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleDraft() {

      // this.basicForm.itemSum = this.task.form.itemSum
      // this.basicForm.tax = this.task.form.tax
      // this.basicForm.taxPrice = this.task.form.taxPrice
      // this.basicForm.totalPrice = this.task.form.totalPrice

      this.handleSubmitForm()
    },
    handleSign() {
      this.$confirm('資料填寫已完成，按下「確定」後將呈主管簽核?', '提醒', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.basicForm.status = "review"
            //this.basicForm.totalPrice = this.task.form.totalPrice

            this.request.post("/todo/signoff", this.basicForm).then(res => {
              if (res.code === '200') {
                this.goBack()
                this.showResult('success', '表單送簽核成功')
              } else {
                this.showResult('error', '表單送簽核失敗')
              }
            })
          }).catch(() => {

          });
    },
    handleInvalid(id) {
      this.request.post("/todo/invalid/" + id).then(res => {
          if (res.code === '200') {
            this.$router.go()
            this.showResult('success', '資料作廢成功.')
          } else {
            this.showResult('error', '資料作廢失敗.')
          }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0
    },
    handleEdit(rowData) {
      // this.dialogFormVisible = true
      // this.form = rowData

      this.editMode = true
      this.actionType = 'update'
      this.task.btnCount = 0
      this.$nextTick(function(){
          this.task.form = rowData
          this.task.form.fileList = []
          this.task.form.fileNotes = []
      })

    },
    handleDelete(id) {
      this.request.delete("/todo/customer/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },

    closeDialog() {
      this.form.notes = ''
      this.$refs['visitForm'].resetFields()
      //this.loadCustomerHistoryData()
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%"
      }
    },
    formDefault() {

      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data
          
          this.taskHistory() 

        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.basicForm.userId = this.userInfo.id
    },
    getTodoType() {
      this.userInfo.id;
    },
    loadPreCheckItem() {
      let req = '/dic/type?queryField=pre_check'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.preCheckOption = res.data
        }
      })
    },
    goBack() {
      this.$router.push('/daily/petty-cash')
    },
    goBackReport() {
      this.$router.push('/report/req-forms-statistic')
    },

    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    saveCustomerVisit(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('valid:', valid)
        if (valid) {
          try {
            //將陣列轉換成後台可以接的字串
            this.form.deliveryContent = this.form.deliveryContentChecked.join(",")
            this.form.serviceContent = this.form.serviceContentChecked.join(",")
            this.form.paymentReceive = this.form.paymentReceiveChecked.join(",")
            this.request.post("/todo/customer/history", this.form).then(res => {
              if (res.code === '200') {
                this.dialogFormVisible = false
                this.loadCustomerHistoryData()
                this.showResult('success', '新增成功')
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })

    },
    loadMyCustomer() {
      this.request.get("/customer/query1?keyword=&all=y").then(res => {
        if (res.code === '200') {
          this.options = res.data
        } else {
          this.options = ['查無負責的客戶名稱']
        }
      })
    },
    newUploadField() {
      this.btnCount++
    },

    removeHistoryFile(id) {
        this.request.delete("/todo/petty-cash/history/file/" + id).then(res => {
          if (res.code === '200') {
            this.taskHistory()
            this.showResult('success', '資料刪除成功.')
          } else {
            this.showResult('error', '資料刪除失敗.')
          }
        })
      },
  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
    }
  },
  mounted() {
    this.form.mytodoId = this.$route.params.mytodoId
    this.task.form.mytodoId = this.$route.params.mytodoId

    let from = this.$route.query.from
    if (typeof from === 'undefined') {
      this.from = ''
    } else {
      this.from = from
    }
    
    //設定一些欄位預設值
    this.formDefault()

    
    this.setDialogWidth();

  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 10px;
}

main >>> .el-card__body {
  padding: 20px 16px;
}
.itemMain >>> .el-card__body {
  padding: 0px 16px;
}

.myform >>> .el-form-item__label {
  padding: 0px;
}
.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}
.el-table {
  padding: 0;
}

.mytitle >>> .el-form--label-top .el-form-item__label {
  padding: 0 !important;
}
</style>
